
import {Component, Prop, Vue} from "vue-property-decorator";
import $ from 'jquery';

@Component
export default class LandingSection extends Vue {
  private adsFooterSm = '';
  private adsFooterMd = '';
  private adsFooterLg = ''

  @Prop()
  gridMd: string;
  @Prop()
  gridXl: string;

  @Prop()
  hasAdsFooter: boolean;

  @Prop()
  hasMidColumn: boolean;

  @Prop()
  hasSingleSection: boolean;

  @Prop()
  contentsClass: string;

  public mounted() {
    (this.gridMd || '6.6').split(".").forEach((value, index) => {
      $(`.outer-col-${index}`).addClass(`col-md-${value}`);
    });
    (this.gridXl || '8.4').split(".").forEach((value, index) => {
      $(`.outer-col-${index}`).addClass(`col-xl-${value}`);
    });
    this.adsFooterSm = document.getElementById('ads-footer-sm-tmpl')?.innerHTML;
    document.getElementById('ads-footer-sm-tmpl')?.remove();
    this.adsFooterMd = document.getElementById('ads-footer-md-tmpl')?.innerHTML;
    document.getElementById('ads-footer-md-tmpl')?.remove();
    this.adsFooterLg = document.getElementById('ads-footer-lg-tmpl')?.innerHTML;
    document.getElementById('ads-footer-lg-tmpl')?.remove();
  }

  private isDisplayed(selector: string): boolean {
    return $(selector).css("display") !== "none";
  }
}
